import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import RawImage from '../components/rawimage.js'

const Image = props => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.images.edges.find(n => {
        return n.node.relativePath.includes(props.filename);
      });
      if (props.filename && image && image.node && image.node.childImageSharp && image.node.childImageSharp.fluid ) {
          //const imageSizes = image.node.childImageSharp.sizes; sizes={imageSizes}
          const fluid = image.node.childImageSharp.fluid
          return <Img {...props} fluid={fluid} />;
      }
        else {
            return <RawImage {...props} />
        }
    }}
  />
);

export default Image
